module.exports = __webpack_public_path__ + "static/media/mtl-logo.87bd045c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mtl-logo.jpg
// module id = 432
// module chunks = 0